import { NSARouterMakerResult } from "namirasoft-account-react";
import { BalanceEntities } from "../BalanceEntities";
import { BalanceLayout } from "../BalanceLayout";
import { BalanceRouterProps } from "../BalanceRouterProps";

export interface SummaryViewPageProps extends NSARouterMakerResult, BalanceRouterProps { }

function SummaryViewPage(props: SummaryViewPageProps)
{
    return (
        <BalanceLayout
            {...props}
            pages={{
                entity: BalanceEntities.summary(props, ""),
                view: {}
            }}
        >
            <></>
        </BalanceLayout>
    );

}

export default SummaryViewPage;